import React, { useState, useEffect, useContext } from 'react';
import { Row, Col, Card, Button, Modal, Form } from 'react-bootstrap';
import axios from 'axios';
import {
  apiUrl,
  myHeaders_With_Cache_Control,
//   myHeaders_Authorized,
//   myHeaders_Auth_With_Cache_Control,
  user_access_level
} from 'Api/Api';
//import FullPageSpinner from 'components/FullPageSpinner/FullPageSpinner';
import ActivityIndicator from 'components/ActivityIndicator/ActivityIndicator';
//import { user_access_level } from 'Api/Api';
import { get_current_unix_stamp } from 'utils/Helper';
import UserContext from 'store/UserContext';

function PechaKuchaJobs(props) {
  const [getJobs, setGetJobs] = useState();
  const [showAdd, setShowAdd] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [jobTitle, setJobTitle] = useState('');
  const [jobDesc, setJobDesc] = useState('');
  const [jobLink, setJobLink] = useState('');
  const [jobPostingKey, setJobPostingKey] = useState('');
  const [saving, setSaving] = useState(false);
  
  const [message, setMessage] = useState(<span>&nbsp;</span>);
  const [validated, setValidated] = useState(false);

  //captures values of the job field for adding
  const handleJobTitleTyping = (e) => {
    setMessage(<span>&nbsp;</span>);
    setJobTitle(e.target.value);
  };
  const handleJobDescTyping = (e) => {
    setMessage(<span>&nbsp;</span>);
    setJobDesc(e.target.value);
  };
  const handleJobLinkTyping = (e) => {
    setMessage(<span>&nbsp;</span>);
    setJobLink(e.target.value);
  };
  const user_context = useContext(UserContext);
  //const entity_identifier = props.match.params.otherpage;

  //This is the api call to get the Jobs
  async function getJobsData() {
    const response = await axios.get(
      //`${apiUrl}managed_contents/${entity_identifier}`,
      `${apiUrl}managed_contents/jobs`,
      myHeaders_With_Cache_Control
    );
    console.log('*******hello*******', response.data);
    return response.data;
  }

  //This is the api call to UPDATE the Job(s)
  async function updateJobsData(jobKey) {
    //setSaving(true);
    console.log('$$$$$$$ Update JOB ########');
    if (jobLink.length < 1 || jobDesc.length < 1 || jobTitle.length < 1) {
    //if (!jobLink || !jobDesc || !jobTitle) {
      setMessage(<span style={{ color: 'red' }}>Please fill out each field</span>);
      setValidated(true);
      return;
    } else {
      //setup patch
      let jobEditPatch = {
        content_sections: {
          [jobKey]: {
            link_url: jobLink,
            text_content: jobDesc,
            title: jobTitle
          }
        }
      };
      setSaving(true);
      setMessage(<span style={{ color: 'green' }}>Saving...</span>);
      await axios.patch(
        `${apiUrl}managed_contents/${getJobs.entity_uuid}`,
        jobEditPatch
      );
      setGetJobs(await getJobsData());
      //await setSaving(false);
    }
    
    
    handleCloseEdit();
    setSaving(false);
    
    /*
    setMessage('');
    setJobTitle('');
    setJobDesc('');
    setJobLink('');
    setShowEdit(false);
    */
  }

  //This is the api call to DELETE the Job(s)
  async function deleteJobsData(jobKey) {
    console.log('$$$$$$$ DELETED JOB ########');
    //setup patch
    let jobDeletePatch = {
      content_sections: {
        [jobKey]: {}
      }
    };

    await axios.patch(
      `${apiUrl}managed_contents/${getJobs.entity_uuid}`,
      jobDeletePatch
    );
    setGetJobs(await getJobsData());
    setShowEdit(false);
  }

  //this is the api call to SUBMIT a job
  async function handleSubmitJob() {
    //setSaving(true);
    let maxJobNum = Number.MIN_VALUE;
    for (const jobKey in getJobs.content_sections) {
      //const jobNum = jobKey.slice(-1); // this does not work for job# > 9
      // proper logic is: const jobNum = jobKey.split('_').pop();
      // but let's use unixtime instead to help prevent race conditions, and also will be sorted for us automagically
      maxJobNum = get_current_unix_stamp();
    }
    const newJobKey = `job_posting_${++maxJobNum}`;
    console.log('****** ADDED JOB *******');
    // setup patch for adding a new job with validation
    if (jobLink.length < 1 || jobDesc.length < 1 || jobTitle.length < 1) {
    //if (!jobLink || !jobDesc || !jobTitle) {
      setMessage(<span style={{ color: 'red' }}>Please fill out each field</span>);
      setValidated(true);
      return;
    } else {
      let jobAddPatch = {
        content_sections: {
          [newJobKey]: {
            link_url: jobLink,
            text_content: jobDesc,
            title: jobTitle
          }
        }
      };
      setSaving(true);
      setMessage(<span style={{ color: 'green' }}>Saving...</span>);
      await axios.patch(
        `${apiUrl}managed_contents/${getJobs.entity_uuid}`,
        jobAddPatch
      );
      setGetJobs(await getJobsData());
      //await setSaving(false);
    }
    
    handleCloseAdd();
    setSaving(false);
    /*
    setMessage('');
    setJobTitle('');
    setJobDesc('');
    setJobLink('');
    setShowAdd(false);
    */
  }

  //this sends the get request for the api on page load
  useEffect(() => {
    if (!getJobs) {
      (async () => {
        try {
          // await axios.post(`${apiUrl}managed_contents`, {
          //     friendly_url: 'jobs',
          //     content_sections: {
          //         job_posting_1:{
          //             link_url: 'https://www.builtinchicago.org/job/engineer/front-end-software-development-engineer-senior/129031',
          //             text_content: 'Want to leverage your React.js experience to shape the future of storytelling? Learn more here: https://www.builtinchicago.org/job/engineer/front-end-software-development-engineer-senior/129031',
          //             title: 'Front-End Software Development Engineer (Senior)'
          //         }
          //       }
          // })
          //use the code above to start over if the whole thing gets deleted
          //comment out the setGetJobs function below to run the code above
          setGetJobs(await getJobsData());
        } catch (err) {
          console.log('Something wrong!', err);
        }
      })();
    }
  });

  //these functions open and close the modal for adding a job
  const handleCloseAdd = () => {
    setValidated(false);
    setMessage(<span>&nbsp;</span>);
    setJobTitle('');
    setJobDesc('');
    setJobLink('');
    setShowAdd(false);
  };
  const handleShowAdd = () => setShowAdd(true);

  //these functions open and close the modal for editing a job
  const handleCloseEdit = () => {
    setValidated(false);
    setMessage(<span>&nbsp;</span>);
    setJobTitle('');
    setJobDesc('');
    setJobLink('');
    setShowEdit(false);
  };
  const handleShowEdit = (jobData, jobKey) => {
    //the number taken in comes from handleJobNumber
    //these capture the value of the job input fields from the edit modal
    setJobTitle(jobData.title);
    setJobDesc(jobData.text_content);
    setJobLink(jobData.link_url);
    //setJobPostingKey('job_posting_' + number);
    setJobPostingKey(jobKey);
    setShowEdit(true);
  };

  /*
  const handleJobNumber = (num) => {
    //get the job posting keys
    let jobPostings = Object.keys(getJobs.content_sections);
    //loop through each one and...
    for (let i = 0; i < jobPostings.length; i++) {
      // if the 2 indexes match, (num and jobPosting[i])
      if (jobPostings.indexOf(jobPostings[i]) === num) {
        //then we're going to split and splice to get the number at the end
        let splitJobPosting = jobPostings[i].split('');
        splitJobPosting.splice(0, splitJobPosting.length - 1);
        //Then we parse it into an Integer
        let jobPostingNumber = parseInt(splitJobPosting.join(''));
        //then return the number to be handled elsewhere
        return jobPostingNumber;
      }
    }
  };
  */

  return (
    <div className="container">
      <Row className="pad-top30 pad-bot10">
        <Col xs={12} className="pad0 d-flex justify-content-between">
          <h1>PechaKucha Jobs and Careers</h1>
          {user_access_level === 'admin' ? (
            <Button style={{ maxHeight: '55px' }} onClick={handleShowAdd}>
              Add Job
            </Button>
          ) : (
            <Button className="d-none" onClick={handleShowAdd}>
              Add Job
            </Button>
          )}
        </Col>
        {/* This modal ADDS a Job */}
        <Modal show={showAdd} onHide={handleCloseAdd}>
          <Modal.Header closeButton>
            <Modal.Title style={{ color: 'black' }}>Add a new job</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form validated={validated} onSubmit={(e) => e.preventDefault()}>
              <Form.Group controlId="jobTitle">
                <Form.Label>Job Title</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Job Title"
                  onChange={handleJobTitleTyping}
                  //className={jobTitle.length < 1 ? 'is-invalid' : 'is-valid'}
                  required
                  disabled={saving}
                />
              </Form.Group>

              <Form.Group controlId="jobDescription">
                <Form.Label>Job Description</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={4}
                  placeholder="Enter Job Description"
                  onChange={handleJobDescTyping}
                  //className={jobDesc.length < 1 ? 'is-invalid' : 'is-valid'}
                  required
                  disabled={saving}
                />
              </Form.Group>

              <Form.Group controlId="jobLink">
                <Form.Label>Job Link</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Job Link"
                  onChange={handleJobLinkTyping}
                  //className={jobLink.length < 1 ? 'is-invalid' : 'is-valid'}
                  required
                  disabled={saving}
                />
              </Form.Group>
            </Form>
            {message}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseAdd}>
              Close
            </Button>
            <Button variant="primary" type="submit" onClick={handleSubmitJob}>
              Save Job
            </Button>
          </Modal.Footer>
        </Modal>

        {getJobs ? (
          <Row className="container my-2 d-flex justify-content-center">
            {Object.keys(getJobs.content_sections).map((jobKey, index) => (
            //{Object.values(getJobs.content_sections).map((job, index) => (
              <Card
                className="col-lg-3 px-0 mx-2 my-2"
                key={index + 1}
                bg={user_context.theme}
                text={user_context.theme === 'light' ? 'dark' : 'white'}
              >
                <Card.Header className="d-flex justify-content-between">
                  <Card.Title>{getJobs.content_sections[jobKey].title}</Card.Title>
                  {user_access_level === 'admin' && 
                    <Button
                      className="mx-2"
                      style={{ maxHeight: '40px' }}
                      onClick={() =>
                        //handleShowEdit(getJobs.content_sections[jobKey], handleJobNumber(index))
                        handleShowEdit(getJobs.content_sections[jobKey], jobKey)
                      }
                    >
                      Edit
                    </Button>
                  }
                </Card.Header>
                <Card.Link
                  href={getJobs.content_sections[jobKey].link_url}
                  style={
                    user_context.theme === 'light'
                      ? { color: 'black' }
                      : { color: 'white' }
                  }
                  bg={user_context.theme}
                  target="_blank"
                >
                  <Card.Body>
                    <Card.Text>{getJobs.content_sections[jobKey].text_content}</Card.Text>
                    <h6
                      className="mt-2"
                      style={{ textDecoration: 'underline' }}
                    >
                      Click here for job details
                    </h6>
                  </Card.Body>
                </Card.Link>
              </Card>
            ))}
          </Row>
        ) : (
          <ActivityIndicator theme="spinner" />
        )}
        {/* this modal EDITS a job */}
        <Modal show={showEdit} onHide={handleCloseEdit}>
          <Modal.Header closeButton>
            <Modal.Title style={{ color: 'black' }}>Edit job</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form validated={validated} onSubmit={(e) => e.preventDefault()}>
              <Form.Group controlId="jobTitle">
                <Form.Label>Job Title</Form.Label>
                <Form.Control
                  type="text"
                  onChange={handleJobTitleTyping}
                  defaultValue={jobTitle}
                  //className={jobTitle.length < 1 ? 'is-invalid' : 'is-valid'}
                  required
                  disabled={saving}
                />
              </Form.Group>

              <Form.Group controlId="jobDescription">
                <Form.Label>Job Description</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={4}
                  onChange={handleJobDescTyping}
                  defaultValue={jobDesc}
                  //className={jobDesc.length < 1 ? 'is-invalid' : 'is-valid'}
                  required
                  disabled={saving}
                />
              </Form.Group>

              <Form.Group controlId="jobLink">
                <Form.Label>Job Link</Form.Label>
                <Form.Control
                  type="text"
                  onChange={handleJobLinkTyping}
                  defaultValue={jobLink}
                  //className={jobLink.length < 1 ? 'is-invalid' : 'is-valid'}
                  required
                  disabled={saving}
                />
              </Form.Group>
            </Form>
            {message}
          </Modal.Body>
          <Modal.Footer className="d-flex">
            <Button
              variant="danger"
              className="mr-auto"
              onClick={() => deleteJobsData(jobPostingKey)}
            >
              Delete
            </Button>
            <Button variant="secondary" onClick={handleCloseEdit}>
              Close
            </Button>
            <Button
              variant="primary"
              type="submit"
              onClick={() => updateJobsData(jobPostingKey)}
            >
              Update Job
            </Button>
          </Modal.Footer>
        </Modal>
      </Row>
    </div>
  );
}

export default PechaKuchaJobs;
